export default () => ({
  gettingGroupBuyingReportList: false,
  gettingMemberReportList: false,
  groupBuyingReportList: {},
  memberReportList: {},
  memberReportRange: [],
  searchDateType: 'start',
});
